// extracted by mini-css-extract-plugin
export default {"Match":"style_Match__Mf0jf","MatchTdTh":"style_MatchTdTh__2sHQ7"};